import { render } from "./Documente.vue?vue&type=template&id=c4634bd0&scoped=true&ts=true"
import script from "./Documente.vue?vue&type=script&lang=ts"
export * from "./Documente.vue?vue&type=script&lang=ts"

import "./Documente.vue?vue&type=style&index=0&id=c4634bd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4634bd0"]])

export default __exports__